// Review lib/algolia/constants/languages.ts when more languages are added
const SMARTLING_LOCALES = {
  ar: { name: 'Arabic' },
  'da-DK': { name: 'Danish' },
  'de-DE': { name: 'German' },
  'el-GR': { name: 'Greek' },
  'en-US': { name: 'English' },
  'es-ES': { name: 'Spanish' },
  'es-LA': { name: 'Latin American Spanish' },
  'fi-FI': { name: 'Finnish' },
  'fr-CA': { name: 'Québécois' },
  'fr-FR': { name: 'French' },
  'he-IL': { name: 'Hebrew' },
  // TODO: uncomment when hindi articles are translated
  // 'hi-IN': { name: 'Hindi' },
  'hu-HU': { name: 'Hungarian' },
  'id-ID': { name: 'Indonesian' },
  'it-IT': { name: 'Italian' },
  'ja-JP': { name: 'Japanese' },
  'ko-KR': { name: 'Korean' },
  'nb-NO': { name: 'Norwegian' },
  'nl-NL': { name: 'Dutch' },
  'pl-PL': { name: 'Polish' },
  'pt-BR': { name: 'Brazilian Portuguese' },
  'pt-PT': { name: 'Portuguese' },
  'ru-RU': { name: 'Russian' },
  'sv-SE': { name: 'Swedish' },
  'th-TH': { name: 'Thai' },
  'tr-TR': { name: 'Turkish' },
  'uk-UA': { name: 'Ukrainian' },
  'vi-VN': { name: 'Vietnamese' },
  'zh-TW': { name: 'Traditional Chinese' },
};

module.exports = {
  SMARTLING_LOCALES,
  DEFAULT_LOCALE: 'en-US',
};
